import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WorkflowIdPage.actions.versionHistory', {
    activeTemplateNotFound: 'Active template not found',
    errorWhileFetching: 'Error while fetching workflow with certain version',
});
